// extracted by mini-css-extract-plugin
module.exports = {"default":"Button_default__g4rec","plane":"Button_plane__3EwuZ","empty":"Button_empty__Eqx11"};